import TListProps from "../../../../../../components/Navigation/List/types/TListProps";
import TListItemProps from "../../../../../../components/Navigation/ListItem/types/TListItemProps";
import ListComponent from "../../../../../../components/Navigation/List/List";
import ListItem from "../ListItem/ListItem";

const List = (props: TListProps) => {
  return (
    <ListComponent
      loading={props.loading}
      title={props.title}
      isDropdownList={props?.isDropdownList}
      action1Element={props.action1Element}
      action1ClickHandler={props.action1ClickHandler}
      projectAbbr={
        Array.isArray(props.items)
          ? (props.items[0] as TListItemProps)?.path.split("/")[0]
          : undefined
      }
      onlyIconList={props?.onlyIconList}
    >
      {props.items &&
        props.items.map((item: TListItemProps) => (
          <ListItem
            {...item}
            onlyIconList={props?.onlyIconList}
            key={item.id}
          />
        ))}
      {props.children}
    </ListComponent>
  );
};

export default List;
